import Accueil from 'components/Accueil';
import Cinema from 'components/Cinema';
import VirtualRoom from 'components/VirtualRoom';
import Multiplex from 'components/Multiplex';
import Account from 'components/Account/Account';
import BlastreamRoom from 'components/BlastreamRoom';
import {Faq, Cgv, About} from 'components/StaticPages';

export const TEMPLATES = [
  {id: 'accueil', component: Accueil},
  {id: 'cinema', component: Cinema},
  {id: 'multiplex', component: Multiplex},
  {id: 'account', component: Account},
  {id: 'faq', component: Faq},
  {id: 'cgv', component: Cgv},
  {id: 'about', component: About},
  {id: 'seance', component: VirtualRoom},
  {id: 'blastream', component: BlastreamRoom},
];

const BASE_ROUTES = [
  {url: '/', template: 'accueil'},
  {url: '/mon-compte/:page', template: 'account'},
  {url: '/cinema/:cinema_id', template: 'cinema'},
  {url: '/cinema/:cinema_id/:film_id', template: 'cinema'},
  {url: '/seance/:id', template: 'seance'},
  {url: '/seance/:id/:hash', template: 'seance'},
  {url: '/event/:id/:hash', template: 'multiplex'},
  {url: '/room/:userType/:eventId/:hash/:permission', template: 'blastream'},
  {url: '/room/:userType/:eventId/:hash', template: 'blastream'},
  {url: '/faq/', template: 'faq'},
  {url: '/cgv/', template: 'cgv'},
  {url: '/about/', template: 'about'},
];

export const ROUTES = BASE_ROUTES.reduce((allRoutes, r) => {
  allRoutes.push(r);
  allRoutes.push({
    ...r,
    url: `/e/:tag${r.url}`,
  });
  allRoutes.push({
    ...r,
    url: r.url === '/' ? '/c/:cinema_id' : `/c/:prefixCinemaId${r.url}`,
    template: r.url === '/' ? 'cinema' : r.template,
  });
  return allRoutes;
}, []);
